import type { RowAction } from '@/components/ui/data-table/types';
import { listMutations } from '@/features/lists/lists.queries';
import { executeMutation } from '@/utils/executeMutation';
import { createListEvent, type ListSummary } from '@certhon/models';
import { CheckCircle } from 'lucide-react';

export { adaptActionsForPanel } from '@/utils/adaptActionsForPanel';

/**
 * Get actions for a checklist - works for both row actions (table) and panel actions
 */
export function getChecklistActions(
  userId: number | null,
): RowAction<ListSummary>[] {
  const actions: RowAction<ListSummary>[] = [];

  // Close/Open action
  actions.push({
    id: 'toggle-status',
    icon: CheckCircle,
    label: (list) => (list.status === 'open' ? 'Mark as completed' : 'Reopen'),
    onCalled: async (list) => {
      if (!userId) {
        return;
      }
      const eventType = list.status === 'open' ? 'CLOSE_LIST' : 'OPEN_LIST';
      executeMutation(listMutations.postEvents(), [
        createListEvent(eventType, {
          list_id: list.id,
          user_id: userId,
          payload: {},
        }),
      ]);
    },
  });

  return actions;
}
